import { type RtkQueryLayers } from '../../core';
import { callSessionOGService } from './callSession.og';

export const callSessionRTKQueryLayers: RtkQueryLayers = {
  reducers: {
    callSessionOGReducerFromLibrary: callSessionOGService.reducer,
  },
  middlewares: [callSessionOGService.middleware],
};
